

  import { useState, useEffect } from "react"
  import { Box, Switch, FormControlLabel, Grid, Button } from "@mui/material"
  import API, { URL_PATH } from "../../services/API"
  import Header from "../../components/Header"
  import Toast from "../../components/Toast"

  function SwitchButtons() {
    const [loading, setLoading] = useState(true)
    const [dineInAvailable, setDineInAvailable] = useState(false)
    const [pickupNowOptAvailable, setPickupNowOptAvailable] = useState(false)
    const [pickupLaterOptAvailable, setPickupLaterOptAvailable] = useState(false)
    const [bookTableAvailable, setBookTableAvailable] = useState(false)
    const [bookHallAvailable, setBookHallAvailable] = useState(false)
    const [closeForDay, setCloseForDay] = useState(false)
    const [online_payment, setOnline_payment] = useState(false)
    const [cash_payment, setCash_payment] = useState(false)
    const [autoKotPrint, setAutoKotPrint] = useState(false)
  const [autoBillPrint, setAutoBillPrint] = useState(false)
  const [autoServeKOT, setAutoServeKOT] = useState(false)

    const [toast, setToast] = useState({
      open: false,
      message: "",
      severity: "success" // 'success', 'error', 'warning', 'info'
    })

    useEffect(() => {
      getData()
    }, [])

    const getData = async () => {
      const response = await API(this, "get", URL_PATH.GET_PREFERENCES)
      const { status, message, data } = response
      console.log()

    if (status === "success") {
      const { hotelConfig } = data
      setDineInAvailable(hotelConfig.dine_in_available)
      setPickupNowOptAvailable(hotelConfig.pickup_now_opt_available)
      setPickupLaterOptAvailable(hotelConfig.pickup_later_opt_available)
      setBookTableAvailable(hotelConfig.book_table_available)
      setBookHallAvailable(hotelConfig.book_hall_available)
      setCloseForDay(hotelConfig.close_for_day)
      setOnline_payment(hotelConfig.online_payment)
      setCash_payment(hotelConfig.cash_payment)
      setAutoKotPrint(hotelConfig.auto_kot_print)
      setAutoBillPrint(hotelConfig.auto_bill_print)
      setAutoServeKOT(hotelConfig.auto_serve_kot)
      setLoading(false)
    }
  }

    const saveConfig = async () => {
      const fd = {
        dine_in_available: dineInAvailable,
        pickup_now_opt_available: pickupNowOptAvailable,
        pickup_later_opt_available: pickupLaterOptAvailable,
        book_table_available: bookTableAvailable,
        book_hall_available: bookHallAvailable,
        close_for_day: closeForDay,
        online_payment: online_payment,
        cash_payment: cash_payment,
        auto_kot_print: autoKotPrint,
        auto_bill_print: autoBillPrint,
              auto_serve_kot: autoServeKOT

      }
      
console.log("Servinggggggggg")
      const { status, message } = await API(this, "post", URL_PATH.saveConfig, fd)

      if (status === "success") {
        showToast("Config saved successfully", "success")
      } else {
        showToast("Failed to save config", "error")
      }
    }

    const handleSwitchChange = (setter) => (event) => {
      setter(event.target.checked)
    }

    const handlePaymentChange = (setter, otherSetter) => (event) => {
      if (!event.target.checked && !otherSetter) {
        showToast("At least one payment method should be enabled", "error")
        return
      }
      setter(event.target.checked)
    }

    const showToast = (message, severity = "success") => {
      setToast({
        open: true,
        message,
        severity
      })
    }

    const handleToastClose = (event, reason) => {
      if (reason === 'clickaway') {
        return
      }
      setToast(prev => ({ ...prev, open: false }))
    }

    if (loading) return (
      <Box>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >

          <div
            style={{
              padding: 15,
              alignSelf: "center",
              borderRadius: "50%",
            }}
          >
            <img
              src={"/Etable Loading.gif"}
              style={{
              width:180 ,
                            height:180,            }}
              className="fade-in"
            />
          </div>
        </div>
      </Box>
    )

    return (
      <>


                                                <Header title="Restro Status" />

      <Box
        sx={{
          margin: "0px auto",
          padding: "30px",
          backgroundColor: "#02111B",
          border: "1px solid #FFC857",
          maxWidth: "300px",
          borderRadius: "8px",
          overflowX: "auto",
        }}
      >

        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={autoBillPrint}
                  onChange={handleSwitchChange(setAutoBillPrint)}
                  color="primary"
                />
              }
              label="Auto Bill Print"
            />
          </Grid> */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={autoKotPrint}
                  onChange={handleSwitchChange(setAutoKotPrint)}
                  color="primary"
                />
              }
              label="Auto KOT Print"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={bookHallAvailable}
                  onChange={handleSwitchChange(setBookHallAvailable)}
                  color="primary"
                />
              }
              label="Book a hall available"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={bookTableAvailable}
                  onChange={handleSwitchChange(setBookTableAvailable)}
                  color="primary"
                />
              }
              label="Book a table available"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={cash_payment}
                  onChange={handlePaymentChange(setCash_payment, online_payment)}
                  color="primary"
                />
              }
              label="In house Payment"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch checked={closeForDay} onChange={handleSwitchChange(setCloseForDay)} color="primary" />
              }
              label="Closed for the day"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch checked={dineInAvailable} onChange={handleSwitchChange(setDineInAvailable)} color="primary" />
              }
              label="Dine In available"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={online_payment}
                  onChange={handlePaymentChange(setOnline_payment, cash_payment)}
                  color="primary"
                />
              }
              label="Online Payment"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={pickupLaterOptAvailable}
                  onChange={handleSwitchChange(setPickupLaterOptAvailable)}
                  color="primary"
                />
              }
              label="Pickup later available"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={pickupNowOptAvailable}
                  onChange={handleSwitchChange(setPickupNowOptAvailable)}
                  color="primary"
                />
              }
              label="Pickup now available"
            />
          </Grid>
                  <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={autoServeKOT}
                  onChange={handleSwitchChange(setAutoServeKOT)}
                  color="primary"
                />
              }
              label="Auto Serve Kot"
            />
          </Grid>

        </Grid>
    
        <Box sx={{ mt: 3, textAlign: "left" }}>
          <Button
            variant="contained"
            onClick={saveConfig}
            sx={{
              backgroundColor: "#FFC857",
              fontWeight: "700",
              color: "black",
              "&:hover": {
                backgroundColor: "#FFC857",
                color: "black",
              },
            }}
          >
            Save
          </Button>
        </Box>
    
        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={handleToastClose}
        />
      </Box>
      </>
    );
    
  }

  export default SwitchButtons